<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>
    <!-- <v-card> -->
    <v-row dense
           class="mx-16">
      <v-col cols="12"
             sm="12"
             md="12"
             lg="12"
             class="mt-2">
        <v-card-title class="font-weight-bold grey lighten-2">
          GEO Meta Information
        </v-card-title>
        <v-expansion-panels class="mt-1">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down"
                                      style="padding: 10px 25px">
              <div class="d-flex font-weight-bold">
                <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                <v-chip outlined
                        small
                        color="success"
                        class="ml-2"
                        @click="showAll()">
                  Select All
                </v-chip>
                <v-chip outlined
                        small
                        color="error"
                        class="ml-2"
                        @click="showDefault()">
                  Select Default
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="v-item-group">
                <v-checkbox v-for="(header, index) in headers"
                            :key="index"
                            :label="header.text"
                            :value="header.text"
                            v-model="selectedHeader"
                            dense
                            class="mx-1"></v-checkbox>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-data-table dense
                      class="data-table-style mt-1"
                      :headers="selectedHeaders"
                      fixed-header
                      :items="geo_meta"
                      item-key="_id"
                      :search="search"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      :items-per-page="itemsPerPage"
                      :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'mdi-page-first',
      lastIcon: 'mdi-page-last',
      'items-per-page-options':[5,10,15,20,50,100,-1] }">
          <!-- item.project_id slot -->
          <template v-slot:[`item.project_id`]="{item}">
            <a @click="goToGEO(item.project_id)">
              <span class="font-weight-bold">{{item.project_id}}</span> </a>
          </template>

          <!-- item.title slot -->
          <template v-slot:[`item.title`]="{item}">
            <span class="">{{item.title}}</span>
          </template>

          <!-- item.pubmed slot -->
          <template v-slot:[`item.pubmed`]="{item}">
            <span v-if="item.pubmed.includes(',')">
              <span v-for="(pubmed_id, index) in item.pubmed && item.pubmed.split(',')"
                    :key="index">
                <a :href="pubmedLink+pubmed_id"
                   target="_blank">{{ pubmed_id }} </a><br>
              </span>
            </span>
            <span v-else>
              <a :href="pubmedLink+item.pubmed"
                 target="_blank">{{ item.pubmed }}</a>
            </span>
          </template>

          <!-- item.healthy_condition slot -->
          <template v-slot:[`item.healthy_condition`]="{item}">
            <span v-if="item.healthy_condition.includes(',')">
              <li v-for="(hc, index) in item.healthy_condition && item.healthy_condition.split(', ')"
                  :key="index"
                  style="text-align: center; list-style-type: none;">
                {{ hc }}
              </li>
            </span>
            <span v-else>
              <span>{{ item.healthy_condition }}</span>
            </span>
            <!-- <a :href="pubmedLink+item.pubmed"
                 target="_blank">{{item.pubmed}}</a> -->
          </template>

          <!-- item.summary slot -->
          <template v-slot:[`item.summary`]="{item}">
            <span v-if="item.summary.length <=100">{{item.summary}}</span>
            <v-tooltip bottom
                       v-else>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">{{item.summary.slice(0, 100) + '...'}}</span>
              </template>
              <span>{{item.summary}}</span>
            </v-tooltip>
          </template>

          <!-- item.overall_design slot -->
          <template v-slot:[`item.overall_design`]="{item}">
            <span v-if="item.overall_design.length <=100">{{item.overall_design}}</span>
            <v-tooltip bottom
                       v-else>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">{{item.overall_design.slice(0, 100) + '...'}}</span>
              </template>
              <span>{{item.overall_design}}</span>
            </v-tooltip>
          </template>

        </v-data-table>

      </v-col>
    </v-row>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import { getGeoMeta } from "node/projects"
export default {
  name: 'GeoMeta',
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Projects',
          disabled: true,
        },
        {
          text: 'GEO',
          disabled: true,
        },
      ],
      geo_meta: [],
      selectedHeader: ['Data Resource', 'BioProject ID', 'Title',
        'Primary Site', 'Healthy Condition', 'Sample Number', 'PMID'],
      search: '',
      loading: true,
      itemsPerPage: 10,
      headers: [
        { text: 'Data Resource', value: 'data_resource', align: 'start', sortable: false, },
        { text: 'BioProject ID', value: 'project_id', align: 'start', sortable: true },
        { text: 'Title', value: 'title', align: 'start', sortable: false, },
        { text: 'Strategy', value: 'strategy', align: 'start', sortable: false, },
        { text: 'Species', value: 'species', align: 'false' },
        { text: 'Primary Site', value: 'tissue', align: 'start', },
        { text: 'Healthy Condition', value: 'healthy_condition', align: 'center', sortable: false, },
        { text: 'Sample Number', value: 'sample_number', align: 'center', sortable: false, },
        { text: 'Summary', value: 'summary', align: 'center', sortable: false, },
        { text: 'Overall Design', value: 'overall_design', align: 'start', sortable: true, },
        { text: 'PMID', value: 'pubmed', align: 'center', sortable: false, },
        { text: 'Release Date', value: 'release_data', align: 'center', sortable: false, },
        { text: 'Submission Date', value: 'submission_data', align: 'center', sortable: false, },
        { text: 'Update Date', value: 'update_data', align: 'center', sortable: false, },
      ],
      pubmedLink: 'https://pubmed.ncbi.nlm.nih.gov/',
    }
  },
  created() {
    this.getGeoMeta();
  },
  watch: {
    geo_meta(val) {
      if (val) {
        this.loading = false;
      }
    },
  },
  computed: {
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    }
  },
  methods: {
    // get all GEO meta info
    async getGeoMeta() {
      await getGeoMeta().then(
        data => {
          if (data.length > 0) {
            // console.log(data);
            this.geo_meta = data;
          } else {
            this.$router.push('/error')
          }
        }
      ).catch(err => console.error(err))
    },
    goToGEO(project_id) {
      this.$router.push({
        path: `/projects/geo/${project_id}`,
      })
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['Data Resource', 'BioProject ID', 'Title',
        'Primary Site', 'Healthy Condition', 'Sample Number', 'PMID'];
    }
  },
}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-sheet.v-card
  border-radius: 15px

.v-card__title
  line-height: 0.5rem

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>